import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard-service.service';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule' },

  //DESCOMENTAR LOS QUE ESTAN COMENTADOS PARA ACTIVAR LA PROTECCION DE RUTAS

  { path: 'menu', loadChildren: './menu/menu.module#MenuPageModule', canActivate: [AuthGuardService] },
  { path: 'pedidos', loadChildren: './pedidos/pedidos.module#PedidosPageModule',canActivate: [AuthGuardService] },
  { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardPageModule',canActivate: [AuthGuardService] },
  { path: 'solicitud', loadChildren: './solicitud/solicitud.module#SolicitudPageModule',canActivate: [AuthGuardService] },
  { path: 'calificacion', loadChildren: './calificacion/calificacion.module#CalificacionPageModule',canActivate: [AuthGuardService] },
  { path: 'reporte', loadChildren: './reporte/reporte.module#ReportePageModule',canActivate: [AuthGuardService] },
  { path: 'signup', loadChildren: './signup/signup.module#SignupPageModule'},
  { path: 'tablapedidos', loadChildren: './tablapedidos/tablapedidos.module#TablapedidosPageModule',canActivate: [AuthGuardService] },
  { path: 'reporte-tarifas', loadChildren: './reporte-tarifas/reporte-tarifas.module#ReporteTarifasPageModule',canActivate: [AuthGuardService] },
  { path: 'lista-tarifas', loadChildren: './lista-tarifas/lista-tarifas.module#ListaTarifasPageModule',canActivate: [AuthGuardService] },
  { path: 'acepta', loadChildren: './acepta/acepta.module#AceptaPageModule',canActivate: [AuthGuardService] },
  
 
  
  
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
